<script>
    import 'number-flow';
    import { onMount } from 'svelte';


    let {
        visited = {},
        total,
        old_visited = 0,
        visited_bold = true,
        highlight_progress = true,
        shrink_on_mobile = false
    } = $props();

    let visited_cnt = $derived(
        (visited && typeof visited === 'object') ? Object.keys(visited).length :
            (typeof visited === 'number') ? visited : 0
    );

    const start_value = $state.snapshot(visited_cnt);
    let done_pc = $derived(total ? Math.round(visited_cnt / total * 100) : 0);

    let flow;
    onMount(() => {
        flow.transformTiming={ easing: 
            'cubic-bezier(0.23, 1, 0.32, 1)',
            duration: 400, delay: 0 };
    });

    $effect(() => flow.update(visited_cnt) );
</script>
<number-flow
    bind:this={flow}
    class:has-text-weight-semibold={visited_bold}
    class:has-text-success={highlight_progress && (visited_cnt > Number(old_visited))}>
{start_value}
</number-flow>{#if total}<span class:is-hidden-touch={shrink_on_mobile}>&nbsp;/&nbsp;{total}&nbsp;({done_pc}%)</span>{/if}

